import React from "react";
import { Merch } from "../components/Merch";

export default function MerchPage({ onJoin }) {
  return (
    <main data-testid="merch-page" className="pt-16">
      <Merch onJoin={onJoin} />
    </main>
  );
}
